import { CountryCode, NumberType, parsePhoneNumberFromString } from 'libphonenumber-js';

const NON_MOBILE_NUMBER_TYPES: ReadonlySet<NumberType> = new Set<NumberType>([
  'PREMIUM_RATE',
  'TOLL_FREE',
  'SHARED_COST',
  'PAGER',
  'UAN',
  'VOICEMAIL',
  'FIXED_LINE',
]);

const isValidMobileNumber = (value: string, defaultCountry: CountryCode = 'GB'): boolean => {
  try {
    const phoneNumber = parsePhoneNumberFromString(value, defaultCountry);
    if (!phoneNumber?.isValid()) return false;

    const lineType = phoneNumber.getType();
    return !lineType || !NON_MOBILE_NUMBER_TYPES.has(lineType);
  } catch {
    return false;
  }
};

export { isValidMobileNumber };
